import * as React from "react";
import i18n from "i18next";

import {Segment, Table} from "semantic-ui-react";
import { SpecDto} from "../../../services/Client";

import DeleteButton from "../../../components/DeleteButton";
import TextField from "../../../components/TextField";

interface IOptionalControls {
    /** Check whether a given DTO has the links to delete itself. */
    canDeleteSpec?: (dto: SpecDto) => boolean;
}

interface ISpecsTableProps {
    /** Spec objects to display in the table. */
    specs?: SpecDto[];

    /** Whether or not the control is waiting for a response from the back end. */
    loading: boolean;

    /** Callbacks to check whether a given DTO has the links for optional features. */
    optionalControls?: IOptionalControls;

    /** Callback for when the table want's to update a spec. */
    onUpdateSpec?: (oldDto: SpecDto, newDto: SpecDto) => any;

    /** Callback for when the table wants to delete a spec. */
    onDeleteSpec?: (dto: SpecDto) => any;

    /** Whether or not the specs codes can be edited. */
    editMode: boolean;
}

interface ISpecsTableState {
}

/**
 * A table-like component that displays a collection of SpecsDtos in a
 * structured way and offers actions to manipulate said specs given
 * the necessary privileges/links.
 *
 * The component doesn't manipulate data itself but relies on the client
 * to provide the necessary call backs to update and delete a spec.
 */
export class SpecsTable extends React.Component<ISpecsTableProps, ISpecsTableState> {
    constructor(props: ISpecsTableProps) {
        super(props);

        this.state = {};
    }

    renderHeader = (): JSX.Element => (
        <Table.Header>
            <Table.Row>
                <Table.HeaderCell>{i18n.t("SPECS:SPEC_CODE_HEADER")}</Table.HeaderCell>
                <Table.HeaderCell>{i18n.t("SPECS:ACTIONS")}</Table.HeaderCell>
            </Table.Row>
        </Table.Header>
    )

    renderSpecCode = (dto: SpecDto): JSX.Element => (
        <Table.Cell>
            <TextField
                name={'specs-table-field'}
                disabled={!this.props.editMode}
                value={dto.specCode}
                onBlur={(e: any, d: any) => {
                    if (dto.specCode !== d && this.props.onUpdateSpec) {
                        let newDto: SpecDto = dto;
                        newDto.specCode = d;
                        this.props.onUpdateSpec(dto, newDto);
                    }
                }}
            />
        </Table.Cell>
    )

    renderActions = (dto: SpecDto): JSX.Element => (
        <Table.Cell>
            {
                this.props.onDeleteSpec &&
                this.props.optionalControls &&
                this.props.optionalControls.canDeleteSpec &&
                this.props.optionalControls.canDeleteSpec(dto) &&
                <DeleteButton
                    label={i18n.t("SPECS:DELETE_SPEC")}
                    confirmLabel={i18n.t("SPECS:CONFIRM")}
                    disabled={this.props.loading}
                    requireConfirmation={true}
                    onClick={() => {
                        if (this.props.onDeleteSpec) {
                            this.props.onDeleteSpec(dto);
                        }
                    }}
                />
            }
        </Table.Cell>
    )

    renderRows = (dtos: SpecDto[]): JSX.Element[] => (
        dtos.map((dto, index) => (
            <Table.Row key={index}>
                {this.renderSpecCode(dto)}
                {this.renderActions(dto)}
            </Table.Row>
        ))
    )

    renderTable = (dtos: SpecDto[]): JSX.Element => (
        <Table>
            {this.renderHeader()}
            <Table.Body>
                {dtos.length > 0 ?
                    this.renderRows(dtos) :
                    <Table.Row>
                        <Table.Cell colSpan={2}>0 {i18n.t("SPECS:ENTRY")}</Table.Cell>
                    </Table.Row>
                }
            </Table.Body>
        </Table>
    )

    render() {
        return (
            <Segment loading={this.props.loading}>
                {this.renderTable(this.props.specs ? this.props.specs : [])}
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/AdminView/ConfigMaintenanceTab/SpecsTable.tsx